// const server = "http://localhost";
// const server2 = "http://localhost";
// const domain = "localhost";
// const port = 9386;
// const port2 = 9411;
const serverImg = 'https://italven.nbg1.your-objectstorage.com/public';
const server = "https://apiitalven.mansolutions.app";
const server2 = "https://apilatintires.mansolutions.app";
const port = 443;
const port2 = 443;
const domain = "italven.mansolutions.app";
export { server, server2, port, port2, domain, serverImg };
